import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const LocationForm = ({ locationId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [locationName, setLocationName] = useState('');
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     // ✅ Fill form if initialData is provided (edit mode)
     useEffect(() => {
          if (initialData && initialData.location) {
               setLocationName(initialData.location);
          }
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!locationName.trim()) {
               setError('Location name is required');
               return;
          }

          setLoading(true);
          setError('');

          try {
               let url = '';
               let method = 'POST';
               let body = {};

               if (locationId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateLocationById/${locationId}`;
                    body = { location: locationName };
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createLocation`;
                    body = { location: locationName };
               }

               const response = await fetch(url, {
                    method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    alert(locationId ? 'Location updated successfully' : 'Location created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/location');
               } else {
                    setError(data.message || `Failed to ${locationId ? 'update' : 'create'} LOCATION`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };
     const handleCloseModal = () => {
          navigate('/location');
     };



     return (
          <form className="general-info-form" onSubmit={handleSubmit}>

               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="locationName"
                              placeholder=" "
                              autoComplete="off"
                              value={locationName}
                              onChange={(e) => setLocationName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="locationName">Location Name</label>
                    </div>
               </div>
               <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
                    {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
                    <button
                         type="submit"
                         className="btn btn-primary"

                         disabled={loading}
                    >
                         {loading ? 'Saving...' : 'Save'}
                    </button>
                    <button
                         type="button"

                         className="btn btn-secondary"
                         onClick={handleCloseModal}
                         disabled={loading}
                    >
                         Cancel
                    </button>
               </div>
          </form>
     );
};

export default LocationForm;
